import React from 'react';
import ReactJson from 'react-json-view';
import API_PUBLIC_SERVICE from './http';
import { DATE_TIME_FRONT_FORMAT } from '../libraries/constants';
import { dateFormat } from '../libraries/formatters';
const PREFIX = 'logs';

const pagePath = '/logs';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'timestamp',
      key: 'timestamp',
      disablePadding: false,
      numeric: false,
      style: {
        width: '150px',
        paddingLeft: '14px',
        paddingRight: '14px'
      },
      label: 'Fecha',
      format: dateFormat(DATE_TIME_FRONT_FORMAT)
    },
    {
      id: 'level',
      key: 'level',
      disablePadding: false,
      numeric: false,
      style: {
        maxWidth: '100px',
        paddingLeft: '14px',
        paddingRight: '14px'
      },
      label: 'Nivel'
    },
    {
      id: 'section',
      key: 'section',
      disablePadding: false,
      numeric: false,
      style: {
        maxWidth: '100px',
        paddingLeft: '14px',
        paddingRight: '14px'
      },
      label: 'Sección'
    },
    {
      id: 'message',
      key: 'message',
      disablePadding: false,
      numeric: false,
      label: 'Mensaje',
      style: {
        wordBreak: 'break-word',
        wordWrap: 'break-word',
        maxWidth: '250px',
        paddingLeft: '14px',
        paddingRight: '14px'
      }
    },
    {
      id: 'description',
      key: 'description',
      disablePadding: false,
      numeric: false,
      label: 'Detalle',
      style: {
        maxWidth: '380px',
        paddingLeft: '14px',
        paddingRight: '14px'
      }
    },
    {
      id: 'user',
      key: 'user',
      disablePadding: false,
      numeric: false,
      style: {
        maxWidth: '150px',
        paddingRight: '15px',
        paddingLeft: '40px',
        wordWrap: 'break-word',
        overflowWrap: 'break-word'
      },
      label: 'Usuario'
    }
  ],

  getKeyTable: () => '_id',
  makeDataTable: values =>
    values.map(value => {
      return {
        ...value,
        section: value.meta && value.meta.section ? value.meta.section : '',
        description: value.meta ? (
          <ReactJson
            name="meta"
            collapsed={true}
            enableClipboard={true}
            displayDataTypes={false}
            src={value.meta}
          />
        ) : (
          ''
        ),
        user:
          value.meta && value.meta.user ? `${value.meta.user.name} ${value.meta.user.lastName}` : ''
      };
    }),
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: true,
  ...pagesRoute
};

//Fecha, Estado, Sección, Descripción, Usuario
const LogService = {
  path: PREFIX,
  ...API_PUBLIC_SERVICE,
  ...tableData
};

export default LogService;
